import { Box, Flex, Heading, Image, ListItem, SimpleGrid, Text, UnorderedList } from "@chakra-ui/react"
import Aos from "aos"
import "aos/dist/aos.css"
import { useContext, useEffect } from "react"
import styled from "styled-components"
import { ColorContext } from "../Context/ColorContext"
// import "../CSS/Skills.css"

function Skills() {
    const { colors, setColors, underLineColor, textColor, family } = useContext(ColorContext)

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])

    return (
        
            <Box  marginTop={"10%"} id="skills" >
            <Heading fontFamily={family} color = 'black' fontSize={35} textAlign={"center"} marginBottom={"4%"} id="skills">Skills</Heading>
                <SimpleGrid columns={[1,1,2,2]} m={'1% 4%'} gap={['4% 4%']}>
                    <Box className="skills-card" data-aos="fade-right" pb={'5%'} boxShadow={'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;'}>
                        <Box bgColor={colors} textAlign={'center'}><Image src="https://i.ibb.co/VDq2CpQ/icons8-html-5-100-1.png" display={'block'} m={'auto'} alt="" w={['7%']} /> <Text fontWeight={'600'} fontSize={['1.1rem']} color={'white'}>Front End</Text></Box>

                        <UnorderedList fontFamily={family} className="skills-card-name" listStyleType={'none'} textAlign={'center'}>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>HTML</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>CSS</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>JavaScript</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>React</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Redux</ListItem>
                        </UnorderedList>
                    </Box>

                    <Box className="skills-card" data-aos="fade-right" pb={'5%'} boxShadow={'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;'}>
                        <Box bgColor={colors} textAlign={'center'}><Image src="https://i.ibb.co/mvGn5yx/icons8-hypertext-markup-language-programming-for-web-pages-and-application-100.png" display={'block'} m={'auto'} alt="" w={['7%']}/><Text fontWeight={'600'} fontSize={['1.1rem']} color={'white'}>Back End</Text></Box>
                        
                        <UnorderedList fontFamily={family} className="skills-card-name" listStyleType={'none'} textAlign={'center'} >
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>ExpressJS</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>MongoDB</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>restful APIs</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>NPM</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>NodeJS</ListItem>
                        </UnorderedList>
                    </Box>

                    <Box className="skills-card" data-aos="fade-right" pb={'5%'} boxShadow={'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;'}>
                        <Box bgColor={colors} textAlign={'center'}><Image src="https://i.ibb.co/VxgWdSH/icons8-flow-chart-100.png" display={'block'} m={'auto'} alt="" w={['7%']} /><Text fontWeight={'600'} fontSize={['1.1rem']} color={'white'}>DSA</Text></Box>
                        
                        <UnorderedList fontFamily={family} className="skills-card-name" listStyleType={'none'} textAlign={'center'} >
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Strings</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Arrays</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Two Pointer</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Linked List</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Stack & Queue</ListItem>
                        </UnorderedList>
                    </Box>

                    <Box className="skills-card" data-aos="fade-right" pb={'5%'} boxShadow={'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;'}>
                        <Box bgColor={colors} textAlign={'center'}><Image src="https://i.ibb.co/nknx3qv/icons8-view-more-100.png" display={'block'} m={'auto'} alt="" w={['7%']} /><Text fontWeight={'600'} fontSize={['1.1rem']} color={'white'}>Other</Text></Box>

                        <UnorderedList fontFamily={family} className="skills-card-name" listStyleType={'none'} textAlign={'center'} >
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>GIT</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Github</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Netlify</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>AWS</ListItem>
                            <ListItem m={'4% 0%'} fontWeight={'600'} fontSize={['1.1rem']}>Linux</ListItem>
                        </UnorderedList>
                    </Box>
                </SimpleGrid>
            </Box>
        
    )

}

export default Skills

